module.exports = __webpack_public_path__ + "static/icon-astronaut-890fcaf09f84ff566a87e48e29856577.png";